import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebSocketApiService {

  constructor(private http: HttpClient) {
  }

  readonly webSocketUrl: string = 'tun';

  public getWebSocketSettings(): Observable<any> {
    return this.http.get(this.webSocketUrl);
  }

    public editWebSocketSettings(webSocketSettings): Observable<any> {
    return this.http.put(this.webSocketUrl, webSocketSettings);
  }
}
